import { VendorOrderTransactionDto } from "../../../dtos/transactions/VendorOrderTransactionDto";
import { format } from "date-fns";
import { DataGrid } from "devextreme-react";
import { Column, ColumnChooser, Grouping, GroupPanel, Pager, Paging, SearchPanel } from "devextreme-react/data-grid";
import { MovementTypeColumn } from "./MovementTypeColumn";
import React from "react";

interface IProps {
    items: VendorOrderTransactionDto[];
}

export const PurchaseOrderTransactionTable = ({ items }: IProps) => {
    const pageSizes = [10, 25, 50, 100];

    return (
        <>
            <div className={"overflow-auto"}>
                <DataGrid
                    dataSource={items}
                    sorting={{ mode: "multiple" }}
                    allowColumnReordering={true}
                    rowAlternationEnabled={false}
                    showBorders={false}
                    showRowLines={true}
                    allowColumnResizing={true}
                    selection={{ mode: "single" }}
                    loadPanel={{ enabled: true, showIndicator: true, showPane: false }}
                >
                    <ColumnChooser enabled={true} />
                    <GroupPanel visible={true} />
                    <SearchPanel visible={true} highlightCaseSensitive={true} />
                    <Grouping autoExpandAll={false} />

                    <Column dataField="tableMovementType"
                        dataType="string"
                        caption={"Movement Type"}
                        width={100}
                        cellRender={(column: any) => {
                            return <MovementTypeColumn column={column} />
                        }} />

                    <Column width={150} dataField={"period"} dataType={"datetime"} caption={"Period"}
                            sortOrder={"asc"}
                            sortIndex={1} />
                    
                    <Column width={200} dataField={"companyName"} dataType="string" />
                    <Column width={75} dataField={"companyId"} dataType="string" />
                    <Column width={200} dataField={"productName"} dataType="string" />
                    <Column width={75} dataField={"productId"} dataType="string" />
                    <Column width={75} dataField={"quantity"} dataType="number" />
                    <Column width={75} dataField={"amountOrdered"} dataType="number" />
                    <Column width={75} dataField={"amountDispatched"} dataType="number" />
                    <Column width={75} dataField={"amountBalance"} dataType="number" />
                    <Column width={75} dataField={"reserveDocumentId"} dataType="string" />
                    <Column width={"*"} dataField={"reserveDocumentDescription"} dataType="string" />


                    <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
                    <Paging defaultPageSize={10} />
                </DataGrid>
            </div>
        </>
    )
}
